import { render, staticRenderFns } from "./GClassManagementCompetencyAllRanking.vue?vue&type=template&id=52fd8444&scoped=true&"
import script from "./GClassManagementCompetencyAllRanking.vue?vue&type=script&lang=ts&"
export * from "./GClassManagementCompetencyAllRanking.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fd8444",
  null
  
)

export default component.exports